import { render, staticRenderFns } from "./CommonDetail.vue?vue&type=template&id=73575303&scoped=true"
import script from "./CommonDetail.vue?vue&type=script&lang=js"
export * from "./CommonDetail.vue?vue&type=script&lang=js"
import style0 from "./CommonDetail.vue?vue&type=style&index=0&id=73575303&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73575303",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73575303')) {
      api.createRecord('73575303', component.options)
    } else {
      api.reload('73575303', component.options)
    }
    module.hot.accept("./CommonDetail.vue?vue&type=template&id=73575303&scoped=true", function () {
      api.rerender('73575303', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/return/components/CommonDetail.vue"
export default component.exports